import {
  TExpirationDate,
  TFieldName,
  TFormField,
  TFormState,
} from '../../reducers/formStateReducer';

export const validateFieldLength = (
  fieldName: TFieldName,
  fieldValue: TFormField | Partial<TExpirationDate>,
): boolean => {
  switch (fieldName) {
    case 'expirationDate':
      return (
        (fieldValue as TExpirationDate).month?.toString().length! <= 2 &&
        (fieldValue as TExpirationDate).year?.toString().length! === 4
      );
    case 'invoiceNumber':
      return (
        (fieldValue as TFormField).value.length === 9 ||
        (fieldValue as TFormField).value.length === 10
      );
    case 'lastFourDigits':
      return (fieldValue as TFormField).value.length === 4;
    default:
      return false;
  }
};

export const isFieldEmpty = (
  fieldName: TFieldName,
  fieldValue: TFormField | Partial<TExpirationDate>,
) => {
  return fieldName === 'expirationDate'
    ? (fieldValue as TExpirationDate).month === undefined ||
        !(fieldValue as TExpirationDate).year === undefined
    : !(fieldValue as TFormField).value;
};

export const allFieldsAreValid = ({
  expirationDate,
  invoiceNumber,
  lastFourDigits,
}: TFormState): boolean => {
  return (
    validateExpirationField(expirationDate) &&
    validateFieldLength('invoiceNumber', invoiceNumber) &&
    validateFieldLength('lastFourDigits', lastFourDigits)
  );
};

export const allFieldsNotEmpty = ({
  invoiceNumber,
  lastFourDigits,
  expirationDate,
}: TFormState): boolean => {
  return (
    !isFieldEmpty('invoiceNumber', invoiceNumber) &&
    !isFieldEmpty('lastFourDigits', lastFourDigits) &&
    !isFieldEmpty('expirationDate', expirationDate)
  );
};

export const getOnlyIntgerValue = ({
  value,
  maxLength,
}: {
  value: string;
  maxLength: number;
}) => {
  return /^\d+$/.test(value) && value.length <= maxLength
    ? value
    : value.substring(0, value.length - 1);
};

export const validateMonthRange = (date: TExpirationDate) => {
  return date.month ? !!(date.month <= 12 && date.month! > 0) : false;
};

export const validateExpirationField = (date: TExpirationDate) =>
  validateFieldLength('expirationDate', date) && validateMonthRange(date);
